import React, { useState } from 'react';
import { CrudStyles } from '../../shared/Crud';
import AddressStepForm from './AddressStepForm';
import deliveryService from '../../../services/deliveryService';
import MessageModal from '../../shared/MessageModal';
import {
    StepFormWrapper,
    FormBlockSeparator,
    DateTimeRow,
    TextAreaStyle,
    splitDateTime,
    combineDateTime,
} from './DetailSectionShared';

const { FormGroup, Button } = CrudStyles;

/**
 * Step de endereço de coleta + dados da coleta (data/hora, instruções).
 * O usuário deve clicar em Salvar/Atualizar para persistir.
 */
export default function PickupAddressStep({
    deliveryId,
    customerIdForApi,
    address,
    onChange,
    errors = {},
    pickupDateTime = '',
    pickupInstructions = '',
    deliveryDateTime = '',
    onPickupDateTimeChange,
    onPickupInstructionsChange,
    onDeliveryDateTimeChange,
    isTransportCompany,
    addressSaved = false,
    onSaveSuccess,
}) {
    const [saving, setSaving] = useState(false);
    const [messageModal, setMessageModal] = useState({ open: false, title: 'Aviso', message: '' });
    const pickup = splitDateTime(pickupDateTime);
    const delivery = splitDateTime(deliveryDateTime);

    const handleSave = async () => {
        if (!deliveryId) {
            setMessageModal({ open: true, title: 'Aviso', message: 'Crie a entrega antes de salvar o endereço de coleta.' });
            return;
        }
        const pickupAddr = address || {};
        const zipCode = String(pickupAddr.zipCode || '').replace(/\D/g, '');
        if (zipCode.length !== 8) {
            setMessageModal({ open: true, title: 'Aviso', message: 'Informe um CEP válido (8 dígitos) para salvar.' });
            return;
        }
        setSaving(true);
        try {
            await deliveryService.updateAddress(deliveryId, pickupAddr, 'GATHERING', {
                customerId: customerIdForApi,
                dateTime: pickupDateTime || null,
                instructions: pickupInstructions || null,
            });
            onSaveSuccess?.();
        } catch (err) {
            setMessageModal({
                open: true,
                title: 'Erro',
                message: err?.message || 'Erro ao salvar endereço de coleta.',
            });
        } finally {
            setSaving(false);
        }
    };

    return (
        <StepFormWrapper>
            <AddressStepForm
                address={address || {}}
                onChange={onChange}
                errors={errors}
            />

            <FormBlockSeparator>
                <FormGroup>
                    <label>{isTransportCompany ? 'Data e hora da coleta' : 'Data da coleta'}</label>
                    <DateTimeRow>
                        <FormGroup>
                            <label style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px', display: 'block' }}>Data</label>
                            <input
                                type="date"
                                value={pickup.date}
                                onChange={(e) => {
                                    const newDate = e.target.value;
                                    onPickupDateTimeChange?.(combineDateTime(newDate, pickup.time));
                                    if (newDate && delivery.date && newDate > delivery.date && onDeliveryDateTimeChange) {
                                        onDeliveryDateTimeChange(combineDateTime(newDate, delivery.time));
                                    }
                                }}
                            />
                        </FormGroup>
                        {isTransportCompany && (
                            <FormGroup>
                                <label style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px', display: 'block' }}>Horário</label>
                                <input
                                    type="time"
                                    value={pickup.time}
                                    onChange={(e) => onPickupDateTimeChange?.(combineDateTime(pickup.date, e.target.value))}
                                />
                            </FormGroup>
                        )}
                    </DateTimeRow>
                </FormGroup>
                <FormGroup>
                    <label>Instruções de coleta</label>
                    <textarea
                        rows={2}
                        value={pickupInstructions || ''}
                        onChange={(e) => onPickupInstructionsChange?.(e.target.value)}
                        placeholder="Ex.: Horário preferencial, portaria..."
                        style={TextAreaStyle}
                    />
                </FormGroup>
                <FormGroup style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
                    <Button
                        type="button"
                        variant="primary"
                        onClick={handleSave}
                        disabled={saving}
                        style={{ justifyContent: 'center' }}
                    >
                        {saving ? 'Salvando...' : addressSaved ? 'Atualizar' : 'Salvar'}
                    </Button>
                </FormGroup>
            </FormBlockSeparator>

            {messageModal.open && (
                <MessageModal
                    title={messageModal.title}
                    message={messageModal.message}
                    onClose={() => setMessageModal((m) => ({ ...m, open: false }))}
                />
            )}
        </StepFormWrapper>
    );
}
